import { Box } from '@mui/material';
import React from 'react';

import { Header } from '../types';
import { useSxStyles } from '../useStyles';
export const TableHeader = ({
  headers,
  edit,
}: {
  headers: Header[];
  edit: boolean;
}) => {
  const sxStyles = useSxStyles();
  return (
    <Box component={'thead'}>
      <Box component={'tr'}>
        {headers.map((header, index) => (
          <Box
            component={'th'}
            key={index}
            sx={{
              ...sxStyles.tableHeader,
              width: header.width,
            }}
          >
            {header.title}
            {header.required && edit && (
              <Box component={'i'} sx={sxStyles.required} />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
